import * as React from 'react';
import { connect } from 'react-redux';
import {
    getAllHeadToHeadScoresByChannel,
    getHighestScoreOfAllMatchesByChannel
} from '../reducers/statsTeamVersusRecent';
import {
  getActiveChannelId,
} from '../reducers/gui';

import StatsHeadToHeadPresentation from '../presentations/StatsHeadToHead/StatsHeadToHeadPresentation';
import { getTranslations } from '../reducers/translations';

const mapStateToProps = ( state: any, ownProps: { displayHeadline?: string, displaySubtitle?: string, verticalStretch?: boolean } ) => {
  const activeChannelId: number = getActiveChannelId(state);
  return {
    matches: getAllHeadToHeadScoresByChannel( state, activeChannelId ),
    maxGoals: getHighestScoreOfAllMatchesByChannel( state, activeChannelId ),
    translations: getTranslations( state ),
  }
};

export default connect( mapStateToProps )( StatsHeadToHeadPresentation );
